import {
  Box,
  Button,
  Table,
  Tbody,
  Text,
  Td,
  Tr,
  Thead,
  Th,
} from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const StepThree = ({ setCurrentStep, product }) => {
  const navigate = useNavigate();
  // console.log('Inverter product', product?.data);
  const recommendedProducts = [
    {
      productName: product?.data?.productName,
      modelName: `Weight: ${product?.data?.brandName}`,
      mainFeatures: [
        `Weight: ${product?.data?.weight}`,
        `${
          product?.data?.productDescription ||
          product?.data?.shortDescription ||
          product?.data?.longDescription
        }`,
        `Monthly financing is available for this product
        `,
      ],
    },
  ];

  const handleClick = () => {
    navigate(`/products/category/002/item/${product?.data?.productId}`);
  };

  return (
    <>
      <Box>
        <Text fontSize={'32px'} fontWeight={600} mb={4}>
          Recommended Products
        </Text>
      </Box>
      <Table fontSize={'12px'}>
        <Thead bg={'#DFF2E7'} borderRadius={'4px'}>
          <Tr>
            <Th>Product Name</Th>
            <Th>Model Name</Th>
            <Th>Main Features </Th>
            <Th>Explore More</Th>
          </Tr>
        </Thead>
        <Tbody>
          {recommendedProducts.map((row, i) => (
            <Tr key={i}>
              <Td>{row.productName}</Td>
              <Td>{row.modelName}</Td>
              <Td>
                {row.mainFeatures.map((feature, i) => (
                  <ul key={i}>
                    <li>{feature}</li>
                  </ul>
                ))}
              </Td>
              <Td>
                <Button
                  w={'40px'}
                  fontSize={'14px'}
                  py={6}
                  px={12}
                  colorScheme='green'
                  onClick={handleClick}
                >
                  Explore
                </Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
      <Button
        mt={12}
        onClick={() => setCurrentStep(1)}
        border='1px solid #32C36C'
        py={6}
        px={20}
        color={'brand.10'}
      >
        Re-Calculate
      </Button>
    </>
  );
};

export default StepThree;
